import React from "react";
import "../styles/LoadingSpinner.css";

function LoadingSpinner() {
  return (
    <div className="spinner-container">
      <div className="loading-spinner" />
    </div>
  );
}

export default LoadingSpinner;
